<template>
	<div
		class="winner-container hide"
		ref="winnerRef"
	>
		<div class="top-text hide">
			{{ lastWinners ? 'Cash Bash Winners' : 'Current Standings' }}
		</div>
		<div
			class="top-positions"
			v-if="players && players.length != 0"
		>
			<div
				class="third-position"
				ref="thirdRef"
			>
				<div class="">
					<div class="money-amount"><span>$</span>{{ formatPrice(players[2].amount) }}</div>
					<div class="winner-name">
						{{ players[2].name.split(',')[1] + ' ' + players[2].name.split(',')[0] }}
					</div>
				</div>
			</div>
			<div
				class="first-position"
				ref="firstRef"
			>
				<div class="">
					<div class="money-amount"><span>$</span>{{ formatPrice(players[0].amount) }}</div>
					<div class="winner-name">
						{{ players[0].name.split(',')[1] + ' ' + players[0].name.split(',')[0] }}
					</div>
				</div>
			</div>
			<div
				class="second-position"
				ref="secondRef"
			>
				<div class="">
					<div class="money-amount"><span>$</span>{{ formatPrice(players[1].amount) }}</div>
					<div class="winner-name">
						{{ players[1].name.split(',')[1] + ' ' + players[1].name.split(',')[0] }}
					</div>
				</div>
			</div>
		</div>
		<div class="bottom-section">
			<div
				class="other-tops"
				ref="topListRef"
			>
				<div
					:key="index"
					class="people hide"
					v-for="(tW, index) in topWinners"
				>
					<div class="container">
						<div class="name">
							{{ tW.name.split(',')[1] + ' ' + tW.name.split(',')[0] }}
						</div>
						<div class="store">{{ tW.store }}</div>
					</div>
					<div class="money">
						<span>$</span>
						<div>{{ formatPrice(tW.amount) }}</div>
					</div>
				</div>
			</div>
			<div
				class="top-text hide small"
				ref="bottomText"
			>
				Waiting for host to Continue
			</div>
		</div>
	</div>
</template>

<script>
	import confetti from 'canvas-confetti';

	export default {
		name: 'LiveWinner',
		props: ['goToWinners', 'lastWinners', 'players', 'isGameDisplay'],
		data() {
			return {
				topWinners: [],
				trumpetShort: new Audio('/static/snd/trumpetWinner.mp3'),
				weTheChampions: new Audio('/static/snd/we-the-champions.mp3'),
				explotion2: new Audio('/static/snd/explotion2.mp3'),
				continueState: null,
				continueLabel: null,
			};
		},
		computed: {},
		mounted() {
			this.$watch(
				() => this.lastWinners,
				newValue => {
					if (newValue) {
						setTimeout(() => {
							if (this.isGameDisplay) {
								this.weTheChampions.play();
							}
							setTimeout(() => {
								if (this.isGameDisplay) {
									this.explotion2.play().then(() => {
										setTimeout(() => {
											this.explotion2.pause();
											this.explotion2.currentTime = 0;
										}, 5000);
									});
								}
								this.fire(0.5, 1, 90);
								this.fire(0.5, 0, 270);
								setTimeout(() => {
									this.fire(0.3, 1, 90);
									this.fire(0.7, 1, 90);
									this.fire(0.3, 0, 270);
									this.fire(0.7, 0, 270);
									this.snow();
									setTimeout(() => {
										this.fire(0, 0.7, 360);
										this.fire(1, 0.3, 180);
										setTimeout(() => {
											this.fire(0, 0.3, 360);
											this.fire(1, 0.7, 180);
										}, 1000);
									}, 1000);
								}, 800);
							}, 1200);
							this.continueLabel = 'Continue';
						}, 300);
					}
				},
				{ deep: true },
			);

			this.$watch(
				() => this.goToWinners,
				newValue => {
					if (newValue) {
						if (this.isGameDisplay) {
							this.trumpetShort.play().then(() => {
								setTimeout(() => {
									this.trumpetShort.pause();
									this.trumpetShort.currentTime = 0;
								}, 7000);
							});
						}
						this.players.sort((a, b) => b.amount - a.amount);
						this.topWinners = [...this.players].filter((l, index) => (index > 2) & (index < 18));

						setTimeout(() => {
							this.$refs.winnerRef.style.display = 'block ';
							setTimeout(() => {
								this.$refs.winnerRef.firstChild.classList.remove('hide');
								this.$refs.winnerRef.classList.remove('hide');
								setTimeout(() => {
									if (this.players[0].amount != 0) {
										this.$refs.firstRef.firstChild.classList.add('container');
									}
									setTimeout(() => {
										if (this.players[1].amount != 0) {
											this.$refs.secondRef.firstChild.classList.add('container');
										}
										setTimeout(() => {
											if (this.players[2].amount != 0) {
												this.$refs.thirdRef.firstChild.classList.add('container');
											}
											setTimeout(() => {
												let listCount = 0;
												this.$meetingHub.adminSelectActivePlayer(null);
												if (this.players[3].amount != 0) {
													let inUsers = setInterval(() => {
														this.$refs.topListRef.children[listCount].classList.remove('hide');
														if (listCount == this.$refs.topListRef.children.length - 1) {
															clearInterval(inUsers);

															setTimeout(() => {
																if (!this.lastWinners && this.$refs.bottomText) {
																	this.$refs.bottomText.classList.remove('hide');
																}
															}, 500);
														}
														listCount++;
													}, 100);
												} else {
													setTimeout(() => {
														if (!this.lastWinners && this.$refs.bottomText) {
															this.$refs.bottomText.classList.remove('hide');
														}
													}, 300);
												}
											}, 500);
										}, 100);
									}, 100);
								}, 100);
							}, 500);
						}, 100);
					} else {
						if (this.$refs.topListRef.children.length > 0) {
							Array.from(this.$refs.topListRef.children).forEach(l => {
								l.classList.add('hide');
							});
						}
						this.$refs.winnerRef.classList.add('hide');
						this.$refs.winnerRef.firstChild.classList.add('hide');
						this.$refs.firstRef.firstChild.classList.remove('container');
						this.$refs.secondRef.firstChild.classList.remove('container');
						this.$refs.thirdRef.firstChild.classList.remove('container');

						if (this.lastWinners && this.$refs.buttonContinue) {
							this.$refs.buttonContinue.classList.add('hide');
						}
						setTimeout(() => {
							this.$refs.winnerRef.style = '';
							this.topWinners = [];
						}, 900);
					}
				},
				{ deep: true },
			);
		},
		methods: {
			formatPrice(price) {
				return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			},
			snow() {
				if (this.isGameDisplay) {
					(function snow() {
						confetti({
							particleCount: 1,
							startVelocity: 0,
							ticks: 200,
							gravity: 0.3,
							origin: {
								x: Math.random(),
								y: Math.random() * 0.999 - 0.2,
							},
							colors: ['#69dff4'],
							shapes: ['circle'],
							scalar: Math.random() * (1 - 0.4) + 0.4,
						});
						if (Date.now() < Date.now() + 1) {
							requestAnimationFrame(snow);
						}
					})();
				}
			},
			fire(x, y, angle) {
				if (this.isGameDisplay) {
					var end = Date.now() + 1;
					(function fire() {
						confetti({
							particleCount: Math.floor(200 * 0.25),
							spread: 26,
							startVelocity: 55,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.28),
							spread: 126,
							startVelocity: 55,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.45),
							spread: 76,
							startVelocity: 55,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.15),
							spread: 86,
							startVelocity: 55,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.2),
							spread: 60,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.35),
							spread: 100,
							decay: 0.91,
							scalar: 0.8,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.1),
							spread: 120,
							startVelocity: 25,
							decay: 0.92,
							scalar: 1.2,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.1),
							spread: 120,
							startVelocity: 45,
							origin: { x: x, y: y },
							angle,
						});

						if (Date.now() < end) {
							requestAnimationFrame(fire);
						}
					})();
				}
			},
		},
		randomInRange(min, max) {
			return Math.random() * (max - min) + min;
		},
	};
</script>
